import * as angular from 'angular';
import { ClButtonComponent } from './cl-button';
import { ClHeaderComponent } from './cl-header';
import { ClSectionComponent } from './cl-section';
import { ClVirtualRepeaterSearchComponent } from './cl-virtual-repeater-search';

const componentModule = angular.module('app.areas.common.components', []);

componentModule
    .component('clHeader', new ClHeaderComponent())
    .component('clSection', new ClSectionComponent())
    .component('clVirtualRepeaterSearch', new ClVirtualRepeaterSearchComponent())
    .component('clButton', new ClButtonComponent())

export default componentModule.name;
